export function priceFormatter(priceCents) {
  return `$${priceCents / 100} (incl. tax + delivery)`;
}

export function priceDecimalFormatter(priceCents) {
  return (priceCents / 100).toFixed(2);
}
